import React from 'react'
import { TextField, IconButton, Typography, type Theme } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import {
    FirstPage as FirstPageIcon,
    LastPage as LastPageIcon,
    NavigateBefore as NavigateBeforeIcon,
    NavigateNext as NavigateNextIcon,
} from '@mui/icons-material'

import { useJasperReport } from './useJasperReport'
import { useSearchParams } from '@edge/spark/utils'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonBar: {
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(2),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
        },
        textField: {
            fontSize: '14px',
            fontWeight: 500,
            color: '#666666',
            width: '40px',
            marginRight: theme.spacing(1),
        },
    }),
)

const ReportPaginationControls = () => {
    const { helper, totalPages } = useJasperReport()
    const [currentPage, setCurrentPage] = React.useState(1)
    const { report } = useSearchParams()
    const classes = useStyles()
    const disabled = !helper

    // ********PAGINATION FUNCTIONS*********
    const navNextPage = (): void => {
        if (helper) {
            const newPage = currentPage + 1
            helper.renderNewPage(newPage)
            setCurrentPage(newPage)
        }
    }
    const navPrevPage = (): void => {
        if (helper) {
            const newPage = currentPage - 1
            helper.renderNewPage(newPage)
            setCurrentPage(newPage)
        }
    }
    const navFirstPage = () => {
        if (helper) {
            const newPage = 1
            helper.renderNewPage(newPage)
            setCurrentPage(newPage)
        }
    }
    const navLastPage = () => {
        if (helper) {
            const newPage = totalPages
            helper.renderNewPage(newPage)
            setCurrentPage(newPage)
        }
    }
    const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newPage = event.target.valueAsNumber
        if (helper) {
            helper.renderNewPage(newPage)
            setCurrentPage(newPage)
        }
    }

    React.useEffect(() => {
        setCurrentPage(1)
    }, [report])

    const disableFirstPageIcon = totalPages === 1 || currentPage === 1 || disabled
    const disableLastPageIcon = totalPages === 1 || currentPage === totalPages || disabled

    return (
        <div className={classes.buttonBar}>
            <IconButton size="small" onClick={navFirstPage} disabled={disableFirstPageIcon}>
                <FirstPageIcon />
            </IconButton>
            <IconButton size="small" onClick={navPrevPage} disabled={currentPage === 1 || disabled}>
                <NavigateBeforeIcon />
            </IconButton>
            <TextField
                value={currentPage}
                type="number"
                classes={{ root: classes.textField }}
                disabled={totalPages === 1 || disabled}
                onChange={handlePageChange}
                inputProps={{
                    style: {
                        padding: '5px',
                    },
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                size="small"
            />
            <Typography variant="subtitle2">of {totalPages}</Typography>
            <IconButton size="small" onClick={navNextPage} disabled={currentPage === totalPages || disabled}>
                <NavigateNextIcon />
            </IconButton>
            <IconButton size="small" onClick={navLastPage} disabled={disableLastPageIcon}>
                <LastPageIcon />
            </IconButton>
        </div>
    )
}

export default ReportPaginationControls
